module.exports = __webpack_public_path__ + "static/media/scroll3_5_2.6816781f.png";